// 加载信息，带遮罩（引用计数：并发请求只展示一次 loading）
import { HideLoading as HideLoadingUtil, ShowLoading as ShowLoadingUtil } from '@/utils/uniVab'

let needLoadingRequestCount = 0
let loadingTimer: ReturnType<typeof setTimeout> | null = null
let hideTimer: ReturnType<typeof setTimeout> | null = null

/** 延迟关闭，避免串行请求之间 loading 闪烁 */
const HIDE_DELAY = 150

export function showLoading(title = '', mask = true) {
  if (hideTimer) {
    clearTimeout(hideTimer)
    hideTimer = null
  }

  if (needLoadingRequestCount === 0) {
    ShowLoadingUtil({
      title,
      mask,
    })

    // 最长10s自动关闭
    loadingTimer = setTimeout(() => {
      if (needLoadingRequestCount > 0) {
        needLoadingRequestCount = 0
        HideLoadingUtil()
      }
      loadingTimer = null
    }, 10000)
  }

  needLoadingRequestCount++
}

// 隐藏遮罩
export function hideLoading() {
  if (needLoadingRequestCount <= 0) return

  needLoadingRequestCount--

  if (needLoadingRequestCount === 0) {
    hideTimer = setTimeout(() => {
      if (needLoadingRequestCount === 0) {
        loadingTimer && clearTimeout(loadingTimer)
        loadingTimer = null
        HideLoadingUtil()
      }
      hideTimer = null
    }, HIDE_DELAY)
  }
}
